import { freeWithdrawalTurnoverLimitUSD } from "app/utils/const";
import { FormattedMessage } from "react-intl";
import "./Note.scss";

function Note() {
  return (
    <div className="note">
      <FormattedMessage tagName="span" id="cashier-deposits-free" />
      <span>
        {" "}
        <FormattedMessage id="cashier-one-free-withdrawal" />{" "}
        {freeWithdrawalTurnoverLimitUSD}
      </span>
      <FormattedMessage
        tagName="span"
        id="cashier-withdrawals-bankwire-crypto-free"
      />{" "}
      <span>
        *
        <FormattedMessage id="cashier-turnover-note" />
      </span>
    </div>
  );
}
export default Note;
